import { Injectable } from '@angular/core';
// import {JobCategory} from './job-category';
// import {JOBCATEGORY} from '../../mock-data';


import { CusHttp } from '../../core/services/CusHttp';


//岗位类型列表接口
const JOBCLASSURL  ="v1/position-industry/tree";

@Injectable()
export class JobCategoryService {

  constructor(public _http:CusHttp,) { }

  // getjobCategory():JobCategory[]{
  //       return JOBCATEGORY;
  // }

      //岗位类型
    getjobCategory(){
        return this._http.get(JOBCLASSURL);
    }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/job-category/job-category.service.ts